import { lightTheme } from '@strapi/design-system';

const PLUGIN_ID = 'review-workflows';
/**
 * The name of the feature in the license.
 */
const FEATURE_ID = 'review-workflows';

export const CHARGEBEE_WORKFLOW_ENTITLEMENT_NAME = 'numberOfWorkflows';
export const CHARGEBEE_STAGES_PER_WORKFLOW_ENTITLEMENT_NAME = 'stagesPerWorkflow';

export const STAGE_COLOR_DEFAULT = lightTheme.colors.primary600;

export { FEATURE_ID, PLUGIN_ID };
